export default __webpack_public_path__ + "media/images/react_icons/sign-contract-grey-5bda9d74654dd240bcd9cc0deebfa8a7.svg";